import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ChargeIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				d="M7.94458 22.416C6.79742 21.7097 8.24704 17.955 8.67036 15.4015C8.91716 13.9128 5.72493 14.8831 4.82238 14.6032C2.71151 13.9487 4.88695 10.2495 8.81263 6.1424C12.7383 2.03525 14.7278 0.613445 16.1196 1.08738C17.5114 1.56131 15.8699 5.99388 15.261 9.1533C14.9596 10.7171 18.3926 9.62721 19.2625 10.0221C20.5385 10.6015 20.45 12.1781 15.4898 17.519C10.5297 22.8599 8.80308 22.9446 7.94458 22.416Z"
				strokeWidth="2"
			/>
		</>
	),
});
